export default function setShowLimitForElements(elWidth) {
  const documentWidth = document.documentElement.offsetWidth;
  const result = Math.ceil(documentWidth / elWidth + 3);

  return result;
}
